// src/utils/antdlocaleprovider.jsx

import "dayjs/locale/en";
import "dayjs/locale/th";
import "dayjs/locale/zh-cn";

import React, { useMemo } from "react";

import { ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import thTH from "antd/locale/th_TH";
import zhCN from "antd/locale/zh_CN";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const AntdLocaleProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const antdLocale = useMemo(() => {
    if (currentLang === "th" || currentLang === "th-TH") {
      dayjs.locale("th");
      return thTH;
    }
    if (currentLang === "ch" || currentLang === "zh_CN") {
      dayjs.locale("zh-cn");
      return zhCN;
    }

    dayjs.locale("en");
    return enUS;
  }, [currentLang]);

  return (
    <ConfigProvider
      locale={antdLocale}
      theme={{
        token: {
          // colorPrimary: "#00b96b",
          // borderRadius: 2,
          // colorBgContainer: "#f6ffed",
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default AntdLocaleProvider;
